<template>
  <div class="team">
    <div class="dashboard__tab dashboard__profile-tab">
      <div v-if="superAdminRole" class="db__container-right">
        <div class="db__container-right-head">
          <div class="header___cont">
            <p class="sub-header">
              Manage your team members and their account permissions here.
            </p>
            <svgicon
              class="icon"
              icon="search"
              @click="onsearchMembers"
            ></svgicon>
          </div>
          <button
            class="cta_btn db__container-right-btn"
            @click.prevent="onAddMembers"
          >
            <svgicon icon="add-icon" class="add-icon"></svgicon>
            Add team member
          </button>
        </div>

        <loader :loader="loader"></loader>
        <div class="team">
          <team-member-permission
            v-for="teamMem in teamMembers"
            :key="teamMem.id"
            :teamMem="teamMem"
            :selectedteamMember="selectedteamMember"
            :roleList="roleList"
            @selected="selectedRole = $event"
            @remove-role="roleId => removeRole(roleId, teamMem)"
            @delete-user="deleteMember(teamMem.id)"
            @update-roles="selectedRole => updateRole(selectedRole, teamMem)"
          />
        </div>
      </div>

      <app-modal
        :show="showModal"
        :styleGotten="modalStyle"
        @onclosed="toggleModal"
      >
        <div class="dash_modal_">
          <div v-if="showTeams" class="team_member_container">
            <div class="add_team">
              <h2>
                Add team members
              </h2>
              <p>Invite existing team members or add new ones.</p>
            </div>

            <div class="dashboard_searchbox">
              <div class="dashboard_searchIcon">
                <svgicon class="icon" icon="search"></svgicon>
              </div>
              <input
                type="text"
                v-model="searchBox"
                class="admin_dashboard_search_input"
                placeholder="Search team member"
              />
            </div>
            <div class="members_selected_container">
              <div v-if="searchBox === ''" class="selected_member_div">
                <div class="selected_member_img">
                  <svgicon icon="Combined-Shape"> </svgicon>
                </div>
                <div><span>No members selected yet</span></div>
              </div>

              <div v-if="searchBox !== ''" class="filtered_team_members">
                <div
                  class="filtered_members_details"
                  v-for="(member, i) in searchMembers"
                  :key="i"
                >
                  <div class="filtered_members ">
                    <div class="team">
                      <p class="tname">{{ member.firstname }}</p>
                      <p class="temail">{{ member.email }}</p>
                    </div>

                    <div class="filtered_member_buttons">
                      <button
                        class=" button2"
                        type="button"
                        @click.prevent="addTeamRoles(member)"
                      >
                        Add
                      </button>
                      <button
                        class="button"
                        type="button"
                        @click.prevent="removeTeamMember(member)"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="members_selected_buttons">
              <button
                type="button"
                class="onCancelbutton"
                @click.prevent="onCancel()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="onContinuebutton"
                @click.prevent="onContinue()"
              >
                Continue
              </button>
            </div>
          </div>
          <div v-if="showForm" class="team_invite_form">
            <div class="invite_header">
              <h2>
                Add team members
              </h2>
              <p>Invite team members</p>
            </div>
            <div class="invite___form___contatiner">
              <div class="invite___form">
                <label>First Name</label><br />
                <input
                  type="text"
                  v-model="formData.firstname"
                  required
                  placeholder="Enter first name"
                  class="invite___input"
                />
                <div class="invite_input_error_message">
                  <p>{{ errorMessage.firstnameError }}</p>
                </div>
              </div>
              <div class="invite___form">
                <label>Last Name</label><br />
                <input
                  type="text"
                  v-model="formData.lastname"
                  required
                  placeholder="Enter last name"
                  class="invite___input"
                />
                <div class="invite_input_error_message">
                  <p>{{ errorMessage.lastnameError }}</p>
                </div>
              </div>
              <div class="invite___form">
                <label>Email Address</label><br />
                <input
                  type="email"
                  v-model="formData.email"
                  required
                  placeholder="Enter email address"
                  class="invite___input"
                />
                <div class="invite_input_error_message">
                  <p>{{ errorMessage.emailError }}</p>
                </div>
              </div>
              <div class="invite___form___buttons">
                <button type="button" @click.prevent="onCancel()">
                  Cancel
                </button>
                <button
                  class="continue"
                  type="button"
                  @click.prevent="onContinue()"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>

          <div v-if="showRoles" class="team_roles_container">
            <div class="roles_header">
              <h2>
                Roles
              </h2>
              <p>Set specific permissions for members</p>
            </div>

            <div class="bottom">
              <div class="user_info">
                <div>
                  <p>{{ `${formData.firstname} ${formData.lastname}` }}</p>
                  <p>{{ formData.email }}</p>
                </div>
                <div @click.prevent="deleteMember(formData.id)">
                  <svgicon icon="trash-icon" class="delete_role_icon">
                  </svgicon>
                </div>
              </div>
              <div>
                <select
                  v-model="selectedRole"
                  class="role-dropdown"
                  @change="updateRole(selectedRole)"
                >
                  <option value="" disabled>
                    Add a new role
                  </option>
                  <option
                    v-for="role in roleList"
                    :key="role.id"
                    :value="role"
                    >{{ role.name }}</option
                  >
                </select>
                <div class="role__container" v-show="formData.roles.length">
                  <p class="title">Edit roles</p>
                  <div class="permission__list">
                    <div
                      v-for="(role, index) in formData.roles"
                      :key="index"
                      class="permission__list-item"
                    >
                      <div>
                        <p class="role">{{ role.role }}</p>
                        <div class="permissions">
                          <custom-checkbox
                            v-for="action in role.actions"
                            :key="action.id"
                            v-model="action.default"
                          >
                            <span>{{ action.name }}</span>
                          </custom-checkbox>
                        </div>
                      </div>
                      <p
                        class="remove__role"
                        @click="() => removeRole(role.id)"
                      >
                        Remove role
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn__actions">
                <button @click="handleBack">Back</button>
                <button @click="onSendInvite">
                  <svgicon
                    icon="spinner"
                    v-if="loading"
                    class="button__loader"
                  ></svgicon>
                  Send Invite
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <app-modal
        :show="showErrorModal"
        :styleGotten="promptModalStyle"
        @onclosed="showErrorModal = false"
      >
        <div class="prompt">
          <svg
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z"
              fill="#CC1D1D"
            />
            <path
              d="M40.4574 15.1929L36.2464 10.9824L25.7199 21.5094L15.1929 10.9824L10.9824 15.1929L21.5089 25.7199L10.9824 36.2469L15.1929 40.4574L25.7199 29.9304L36.2464 40.4574L40.4574 36.2469L29.9299 25.7199L40.4574 15.1929Z"
              fill="white"
            />
          </svg>
          <h1 class="prompt__title">Oops...</h1>
          <p class="prompt__text">{{ errorMessage.createUser }}</p>
        </div>
      </app-modal>
      <app-modal
        :show="showSuccessModal"
        :styleGotten="promptModalStyle"
        @onclosed="showSuccessModal = false"
      >
        <div class="prompt">
          <svg
            width="66"
            height="66"
            viewBox="0 0 66 66"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66Z"
              fill="#18CE7F"
            />
            <path
              d="M27.9984 50.118L12.7875 34.907C12.5813 34.7008 12.5813 34.3914 12.7875 34.1852L17.1703 29.8023C17.3766 29.5961 17.6859 29.5961 17.8922 29.8023L28.3594 40.2695L48.0562 20.5727C48.2625 20.3664 48.5719 20.3664 48.7781 20.5727L53.1609 24.9555C53.3672 25.1617 53.3672 25.4711 53.1609 25.6773L28.7203 50.118C28.5141 50.3242 28.2047 50.3242 27.9984 50.118Z"
              fill="white"
            />
          </svg>

          <h1 class="prompt__title">Great!</h1>
          <p class="prompt__text">Admin User created successfully</p>
        </div>
      </app-modal>
    </div>
  </div>
</template>

<script>
import {
  getAdminMembers,
  updateAdminRole,
  removeAdminRole,
  deleteAdminUser,
  createNewAdminUser,
  getAdminRoles
} from "../../../services/dashboard";
import VueCookies from "vue-cookies";
import AppModal from "../resuables/modal.vue";
import loader from "../resuables/loader";
import TeamMemberPermission from "./teamMemberPermission.vue";
import CustomCheckbox from "../resuables/custom-checkbox.vue";
export default {
  components: {
    AppModal,
    loader,
    TeamMemberPermission,
    CustomCheckbox
  },
  data() {
    return {
      checked: false,
      formData: {
        id: null,
        firstname: "taiwo",
        lastname: "joseph",
        email: "taiwo@spleet.ng",
        roles: []
      },
      loader: false,
      loading: false,
      teamMembers: [],
      selectedRole: "",
      showTeams: false,
      showForm: true,
      showRoles: false,
      showModal: false,
      showErrorModal: false,
      showSuccessModal: false,
      updateAdminButton: false,
      checkForm: false,
      searchBox: "",
      roleList: "",
      errorMessage: {
        firstnameError: "",
        lastnameError: "",
        emailError: "",
        createUser: ""
      },

      firstnameValid: false,
      lastnameValid: false,
      emailValid: false,
      selectedteamMember: [],
      selectDropDown: false,
      modalStyle: {
        "max-width": "544px",
        width: "100%",
        height: "fit-content",
        padding: "20px"
      },
      promptModalStyle: {
        "max-width": "350px",
        width: "100%",
        height: "200px",
        "margin-top": "200px",
        padding: "20px"
      },
      callbackURlOrigin: window.location.origin
    };
  },
  methods: {
    handleBack() {
      this.showRoles = false;
      this.showForm = true;
    },
    getAllAdmin() {
      this.loader = true;
      getAdminMembers()
        .then(data => {
          if (data.statusCode == 200) {
            this.loader = false;
            this.teamMembers = data.data;
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },

    getAdminRoles() {
      getAdminRoles()
        .then(data => {
          if (data.statusCode == 200) {
            return (this.roleList = data.data);
          }
        })
        .catch(err => {
          return err;
        });
    },
    onsearchMembers() {
      if (
        this.showTeams === true ||
        this.showForm === true ||
        this.showRoles === true
      ) {
        this.showForm = false;
        this.showRoles = false;
        this.showTeams = true;
        this.toggleModal();
        this.updateAdminButton = true;
      }
    },
    onAddMembers() {
      if (
        this.showTeams === true ||
        this.showForm === true ||
        this.showRoles === true
      ) {
        this.showTeams = false;
        this.showRoles = false;
        this.showForm = true;
        this.toggleModal();
        this.updateAdminButton = false;
      }
    },
    addTeamRoles(member) {
      if (!this.selectedteamMember.includes(member)) {
        this.selectedteamMember.push(member);
        this.showTeams = false;
        this.showRoles = true;
      } else {
        this.showTeams = !this.showTeams;
        this.showRoles = !this.showRoles;
        this.searchBox = "";
      }
    },
    async updateRole(option, member) {
      if (member) {
        const index = member.roles.findIndex(role => role.id === option.id);

        if (index === -1) {
          try {
            const response = await updateAdminRole({
              role: option.name,
              userId: member.id
            });
            if (response.statusCode === 200) {
              const { id, status, roleId, userId } = response.data;
              member.roles.unshift({
                id,
                role: { id: option.id, name: option.name },
                status,
                roleId,
                userId,
                permissions: []
              });
              this.$notification.success({
                message: response.message
              });
            } else {
              this.$notification.error({
                message: response.data.message
              });
            }
          } catch (error) {
            this.$notification.error({
              message: "Error adding role to user",
              description: "Role is not added"
            });
          }
        }
      } else {
        const index = this.formData.roles.findIndex(el => el.id === option.id);
        if (index === -1) {
          const data = {
            id: option.id,
            role: option.name,
            actions: [
              { id: 1, name: "Create", default: false },
              { id: 2, name: "Read", default: false },
              { id: 3, name: "Update", default: false },
              { id: 4, name: "Delete", default: false }
            ]
          };
          this.formData.roles.unshift(data);
        }
      }
    },

    async removeRole(roleId, member) {
      if (member) {
        try {
          const response = await removeAdminRole(roleId);
          if (response.statusCode === 200) {
            const index = member.roles.findIndex(el => el.id === roleId);
            member.roles.splice(index, 1);
            this.$notification.success({
              message: response.message
            });
          } else {
            this.$notification.error({
                message: response.data.message
              });
          }
        } catch (error) {
          this.$notification.error({
            message: "Error occured while deleting user role"
          });
        }
      } else {
        const index = this.formData.roles.findIndex(el => el.id === roleId);
        if (index !== -1) {
          this.formData.roles.splice(index, 1);
        }
      }
    },
    async deleteMember(userId) {
      try {
        const response = await deleteAdminUser(userId);
        if (response.statusCode == 200) {
          const index = this.teamMembers.findIndex(el => el.id === userId);
          this.teamMembers.splice(index, 1);
          this.$notification.success({
            message: response.message
          });
        } else {
          this.$notification.error({
          message: response.data.message,
        });
        }
      } catch (error) {
        this.$notification.error({
          message: "Error occured while deleting user"
        });
      }
    },
    removeTeamMember(member) {
      if (this.teamMembers.includes(member)) {
        this.teamMembers.splice(this.teamMembers.indexOf(member), 1);
      }
    },
    toggleDropdown() {
      this.selectDropDown = !this.selectDropDown;
    },

    onBackForm() {
      if (this.showRoles === true) {
        this.selectedRole = "";
        this.selectedteamMember = [];
        this.showRoles = false;
        this.showForm = true;
      }
    },
    onBackTeams() {
      if (this.showRoles === true) {
        this.selectedRole = "";
        this.searchBox = "";
        this.selectedteamMember = [];
        this.showRoles = false;
        this.showTeams = true;
      }
    },
    onContinue() {
      if (!this.emailValid && !this.lastnameValid && !this.firstnameValid) {
        this.setErrorMessages();
      }

      if (this.emailValid && this.lastnameValid && this.firstnameValid) {
        const member = {
          firstname: this.formData.firstname,
          lastname: this.formData.lastname,
          email: this.formData.email
        };
        if (!this.selectedteamMember.includes(member)) {
          this.selectedteamMember.push(member);
          this.showForm = false;
          this.showRoles = true;
        }
      }
    },
    async onSendInvite() {
      const roles = this.formData.roles.map(el => {
        return {
          roleId: el.id,
          permissionIds: el.actions.reduce((acc, el) => {
            if (el.default) {
              acc.push(el.id);
            }
            return acc;
          }, [])
        };
      });
      const { firstname, lastname, email } = this.formData;
      const payload = {
        firstname,
        lastname,
        email,
        callbackUrl: `${this.callbackURlOrigin}/set-password`,
        roles
      };

      try {
        this.loading = true;
        const response = await createNewAdminUser(payload);
        const data = response.data;
        if (data.statusCode === 201) {
          this.showSuccessModal = true;
          this.$notification.success({
            message: data.message
          });
        }
      } catch (error) {
        this.$notification.error({
          message: "Error creating user"
        });
      } finally {
        this.loading = false;
        this.onCancel();
      }
    },
    clearForm() {
      this.formData.firstname = "";
      this.formData.lastname = "";
      this.formData.email = "";
      this.formData.roles = [];
      this.formData.id = "";
      this.checkForm = false;
      this.setErrorMessagesEmpty();
    },
    setErrorMessages() {
      this.errorMessage.firstnameError = "Please input all fields";
      this.errorMessage.lastnameError = "Please input all fields";
      this.errorMessage.emailError = "Please input all fields";
    },
    setErrorMessagesEmpty() {
      this.errorMessage.firstnameError = "";
      this.errorMessage.lastnameError = "";
      this.errorMessage.emailError = "";
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.searchBox = "";
      this.clearForm();
    },

    onCancel() {
      this.toggleModal();
    },
    onDone() {
      this.onCancel();
    }
  },
  computed: {
    searchMembers() {
      if (this.searchBox !== "") {
        const filteredMembers = this.teamMembers.filter(
          mem =>
            mem.firstname.includes(this.searchBox) ||
            mem.firstname.toLocaleLowerCase().includes(this.searchBox)
        );

        return filteredMembers;
      }
    },

    superAdminRole() {
      const admin = VueCookies.get("admin");
      let superAdmin = false;
      const adminRoles = admin["roles"].map(el => el["role"]);
      adminRoles.forEach(el => {
        if (el === "super admin") {
          superAdmin = true;
        }
      });
      return superAdmin;
    },
    formItems() {
      return this.formData;
    },
    firstnameData() {
      return this.formData.firstname;
    },
    lastnameData() {
      return this.formData.lastname;
    },
    emailData() {
      return this.formData.email;
    }
  },
  watch: {
    firstnameData(val) {
      if (val.length < -1) {
        this.errorMessage.firstnameError = "Please input first name";
        this.firstnameValid = false;
      } else if (val.length === 0) {
        this.firstnameValid = false;
      } else {
        this.errorMessage.firstnameError = "";
        this.firstnameValid = true;
        this.checkForm = true;
      }
    },
    lastnameData(val) {
      if (val.length < -1) {
        this.errorMessage.lastnameError = "Please input last name";
        this.lastnameValid = false;
      } else if (val.length === 0) {
        this.lastnameValid = false;
      } else {
        this.errorMessage.lastnameError = "";
        this.lastnameValid = true;
        this.checkForm = true;
      }
    },
    emailData(val) {
      if (val.length === 0) {
        this.errorMessage.emailError = "Please input email";
        this.emailValid = false;
      } else if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          val
        ) &&
        val.length > 1
      ) {
        this.errorMessage.emailError = "Please provide a valid email address";
        this.emailValid = false;
      } else if (val.length === 0) {
        this.emailValid = false;
      } else {
        this.errorMessage.emailError = "";
        this.emailValid = true;
        this.checkForm = true;
      }
    }
  },
  mounted() {
    this.getAllAdmin();
    this.getAdminRoles();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/teamMembers.vue